<div class="modal--idea">
  <div class="modal-content">
    <ng-container [ngSwitch]="page">
      <ng-container *ngSwitchCase="'description'" [ngTemplateOutlet]="description"></ng-container>
      <ng-container *ngSwitchCase="'finish'" [ngTemplateOutlet]="finish"></ng-container>
    </ng-container>
  </div>
</div>


<ng-template id="description" #description>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 over-gradient">
          <div class="modal--idea__question">
            <div class="modal--idea__wrapper">
              <ng-container [ngTemplateOutlet]="language"></ng-container>
              <h3 class="modal--idea__title">{{"newKaizenIdea" | translate}}</h3>
              <h4 class="modal--idea__step">01</h4>
              <h5 class="modal--idea__section">{{"ideaDescriptionKaizen" | translate}} </h5>
            </div>
            <div class="modal--idea__col">
              <button type="button" class=" modal--idea__back" (click)="onNavScroll('programa')" data-dismiss="modal">
                <svg-icon class="svg" src="assets/images/back.svg"></svg-icon>
                <span>{{"back" | translate}}</span>
              </button>
              <div class="d-flex align-items-center">
                <div class="modal--idea__dots mx-2">
                  <div class="modal--idea__dots-item dots-back"></div>
                  <div class="modal--idea__dots-item dots-now"></div>
                </div>
                <svg-icon class="svg" src="assets/images/logo-icon-white.svg"></svg-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 over-custom">
          <div class="modal--idea__form " style="justify-content: initial;">
            <form class="modal--idea__wrapper mx-auto">
              <div class="input-material">
                <input id="nameAuthor" name="name" class="form-control" type="text" maxlength="250"
                  [(ngModel)]="model.authorName" required />
                <label for="nameAuthor">{{"author.name" | translate}}</label>
              </div>
              <div class="input-material">
                <select id="unity" [(ngModel)]="unityId" class="form-control"
                        name="type">
                    <option *ngFor="let unity of unities" [value]="unity.id">{{unity.name}}</option>
                </select>
                <label for="unity">{{'unity.unityTitle' | translate}}</label>
              </div>
              <div class="d-flex flex-column flex-md-row">
                <div class="flex-grow-1">
                  <div class="input-material">
                    <input
                      id="re"
                      name="text"
                      class="form-control"
                      inputmode="numeric"
                      appOnlyNumber
                      [(ngModel)]="model.re"
                      maxlength="6"
                      required
                    />
                    <label for="re">RE</label>
                  </div>
                </div>
                <div style="width: 1em;height: 0">&nbsp;</div>
                <div class="flex-grow-1">
                  <div class="input-material flex-grow-1">
                    <input type="date" name="createdAt" id="createdAt" class="form-control"
                      [(ngModel)]="model.initialDate">
                    <label for="createdAt">{{"Data de criação" | translate}}</label>
                  </div>
                </div>

              </div>

              <div class="input-material">
                <input id="title" name="title" class="form-control" type="text" maxlength="250"
                  [(ngModel)]="model.title" required />
                <label for="title">{{"ideaMaker.ideaTitle" | translate}}</label>
              </div>

              <div class="flex-grow-1">
                <div class="input-material flex-grow-1">
                  <select [(ngModel)]="model.frame" id="work" name="text" class="form-control">
                    <option *ngFor="let frame of frames" [value]="frame.id" required>
                      {{frame.name}}
                    </option>
                  </select>
                  <label for="work">{{"author.frame" | translate}}</label>
                </div>
              </div>

               <div id="areas" class="mb-4 ">
                <span>Áreas</span>
                <div class="" aria-labelledby="dropdownMenuButton">
                  <ng-container *ngFor="let area of modelAreas; let i = index;">
                    <label class="item">
                      <input type="checkbox" [value]="area" (click)="onChangeArea($event, area)">
                      {{area}}
                    </label>
                  </ng-container>
                </div>
              </div>

              <ng-container>
                <label class="checkbox-label-container">
                  <input type="checkbox" name="problem" />
                  <span class="checkmark" style="border: none;">
                    <span class="align-self-center">{{ "ideaMaker.ideaProblem" | translate}}</span>
                  </span>
                </label>
                <div class="input-material mb-2">
                  <textarea class="form-control" name="problem" rows="5" [(ngModel)]="model.problem"></textarea>
                  <label for="problem">{{"ideaMaker.ideaDescKaizen" | translate}}</label>
                </div>

                <label class="checkbox-label-container">
                  <input type="checkbox" name="Solution" />
                  <span class="checkmark" style="border: none;">
                    <span class="align-self-center">{{ "ideaMaker.ideaSolution" | translate}}</span>
                  </span>
                </label>
                <div class="input-material mb-5">
                  <textarea class="form-control" name="solution" rows="5" [(ngModel)]="model.solution"></textarea>
                  <label for="solution">{{"ideaMaker.ideaDescKaizen" | translate}}</label>
                </div>
              </ng-container>



              <div class="input-material-kaizen ">
                <span>{{ "ideaMaker.ideaSpan" | translate }}</span>
                <div class="input-image-kaizen">
                  <label for="ideaImage">
                    {{ "ideaMaker.ideaCardKaizen" | translate }}
                  </label>
                  <input type="file" id="ideaImage" name="ideaImage" (change)="onImageChange($event)"
                    placeholder="Insira Imagem" required>
                </div>
              </div>
              <div id="image-selected-container-kaizen">
                <button type="button" (click)="toRemoveImage()">
                  <span>X</span>
                </button>
                <div class="content">
                  <img *ngIf="image" [src]="image" alt="Imagem Selecionada">
                  <div class="infor-image">
                    <p>{{image ? inforImage?.type : 'Selecione uma imagem'}}</p>
                    <p>{{ image ? inforImage?.size : '' }}</p>
                  </div>
                </div>
                <div class="progress">
                  <div [ngClass]="{'in-progress' : image}"></div>
                  <p>{{ image ? '100%' : '0%' }}</p>
                </div>
              </div>

              <app-idea-attachments [files]="attachments" [maxFiles]="attachmentSlots"
                                    (filesChange)="attachments = $event"></app-idea-attachments>

              <div class="modal fade modal_author" id="newAuthor" tabindex="-1" role="dialog" aria-labelledby="loginLabel"
                aria-hidden="true"
                data-backdrop="static">
              <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body">
                    <div class="d-flex justify-content-between align-items-center mb-5">
                      <span
                        class="modal_author-title">{{"author.authorAdded" | translate}} {{this.model.authors?.length + 2}}</span>
                      <svg-icon data-dismiss="modal" src="assets/images/close.svg"></svg-icon>
                    </div>
                    <div class="input-material" style="font-size: 19px;">
                      <input
                        id="newName"
                        name="text"
                        class="form-control"
                        [(ngModel)]="modelAuthorDetail.name"
                        maxlength="250"
                        required
                      />
                      <label for="newName">{{"author.name" | translate}}</label>
                    </div>
                    <div class="input-material" style="font-size: 19px;">

                      <input
                        id="re"
                        name="text"
                        class="form-control"
                        [(ngModel)]="modelAuthorDetail.re"
                        maxlength="6"
                        required
                      />

                      <label for="re">RE</label>
                    </div>
                    <div class="input-material" style="font-size: 19px;">
                      <input
                        id="newEmail"
                        name="text"
                        class="form-control"
                        type="email"
                        [(ngModel)]="modelAuthorDetail.email"
                        maxlength="250"
                        required
                      />
                      <label for="newEmail">Email</label>
                    </div>
                    <button
                      data-dismiss="modal"
                      type="button"
                      class="btn-more btn-block effect"
                      (click)="onAddAuthor()"
                    >
                      <span>{{"save" | translate}}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

              <div>
                <a
                  href="javaScript:void(0)"
                  class="btn btn-primary modal--idea_btn-author mt-5"
                  (click)="openModalAuthor('newAuthor')">
                  {{"author.addAuthors" | translate}}
                  <svg-icon src="assets/images/plus-circle.svg">
                  </svg-icon>
                </a>

                <div
                  class="modal--idea_card my-2"
                  *ngFor="let author of model.authors; let i = index;"
                >
                  <div class="d-flex justify-content-between mb-3">
                    <span class="modal--idea_card-title">
                      {{"author.authorAdded" | translate}} {{i + 2}}
                    </span>
                    <span (click)="onRemoveAuthor(i)">
                      <svg-icon
                        src="assets/images/close-circle.svg"
                      >
                      </svg-icon>
                    </span>
                  </div>
                  <div class="input-material">
                    <span>Nome: {{author.name}}</span>
                  </div>
                  <div class="input-material">
                    <span>RE: {{author.re}}</span>
                  </div>
                  <div class="input-material">
                    <span>Email: {{author.email}}</span>
                  </div>
                </div>

                <button type="button" (click)="onStepSaveSecond()" class="btn-more btn-more-second effect-kaizen">
                  <span>{{"save" | translate}}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #finish>
  <div class="modal-body">
    <section class="idea-finish">
      <div class="idea-finish_col-primary">
        <svg-icon [svgClass]="'idea-finish_svg-primary'" src="assets/images/logo-icon-white.svg"></svg-icon>
      </div>
      <div class="idea-finish_col-secondary">
        <div class="idea-finish_col-secondary_padding">
          <svg-icon class="idea-finish_svg-secondary" src="assets/images/logo.svg"></svg-icon>
          <h3 class="idea-finish_text-primary">
            {{"confirmPage.actions" | translate}}
            <br>
            <br>
            {{"confirmPage.thanks" | translate}}
          </h3>
          <p class="idea-finish_text-secondary" [innerHTML]="'confirmPage.follow' | translate"></p>
          <br>
          <form class="d-flex flex-column flex-lg-row" style="gap: 30px;">
            <button (click)="onBackModal('description')" type="button" style="width: initial"
              class="btn-more effect flex-grow-1 mt-0">
              <span>{{"confirmPage.registerAnother" | translate}}</span>
            </button>
            <ng-container *ngIf="!recordStream">
              <button (click)="onNextModal('challenge')" type="button"
                class="btn btn-close btn-outline-white flex-grow-1">
                <span>{{"close" | translate}}</span>
              </button>
            </ng-container>
          </form>
        </div>
      </div>

    </section>
  </div>
</ng-template>

<ng-template #language>
  <div class="text-white">
    <div class="header__language align-items-start" style="display: flex !important;">
      <strong>Idioma</strong>
      <ul class="d-flex" style="list-style-type: none">
        <li><a href="javascript:void('');" [ngClass]="{'active' : translate.currentLang === 'pt'}"
            (click)="switchLanguage('pt', false);">PT</a></li>
        <li><span>|</span></li>
        <li><a href="javascript:void('');" [ngClass]="{'active' : translate.currentLang === 'es'}"
            (click)="switchLanguage('es', false);">ES</a></li>
      </ul>
    </div>
  </div>
</ng-template>
